import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import FleerunStore from "./store";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import GlobalComponents from "./shared/fleetbox-components";

import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import VueLodash from "vue-lodash";
import { loadMessages } from "@progress/kendo-vue-intl";
import VueClipboard from "vue-clipboard2";

import moment from "moment";
import momentD from "moment-duration-format";

import Unicon from "vue-unicons";
import { uniFileDownload } from "vue-unicons/src/icons";

import lessStyles from "./less/style.less";

Unicon.add([uniFileDownload]);
Vue.use(Unicon);

require("moment/locale/it");
moment.locale("it");

Vue.use(VueClipboard);

Vue.filter("b64toBlob", function(value) {
	var byteString = atob(value);
	var ab = new ArrayBuffer(byteString.length);
	var ia = new Uint8Array(ab);

	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ab], { type: "application/octet-stream" });
});

Vue.filter("datetimeToString", function(value) {
	if (!value) return "";
	return moment(value).format("DD/MM/YYYY HH:mm:ss");
});
Vue.filter("datetimeToStringDot", function(value) {
	if (!value) return "";
	return moment(value).format("DD.MM.YYYY_HH.mm.ss");
});
Vue.filter("mToKm", function(value) {
	if (!value) return "";

	var distanceStr = "";
	var dKm = value / 1000;
	distanceStr = `${dKm.toFixed(2)}`;

	return distanceStr;
});
Vue.filter("dateToString", function(value) {
	if (!value) return "";

	return moment(value, [moment.RFC_2822, moment.ISO_8601, "DD/MM/YYYY"]).format("DD/MM/YYYY");
});
Vue.filter("dateToStringDot", function(value) {
	if (!value) return "";

	return moment(value, [moment.RFC_2822, moment.ISO_8601, "DD/MM/YYYY"]).format("DD.MM.YYYY");
});
Vue.filter("timeToString", function(value) {
	if (!value) return "";
	return moment(value).format("HH:mm:ss");
});
Vue.filter("timeToStringHHmm", function(value) {
	if (!value) return "";
	return moment(value).format("HH:mm");
});
Vue.filter("timeFromSecondsToString", function(value) {
	if (!value) return "00:00:00";

	var tt = moment.duration(value, "seconds");

	return tt.format("HH:mm:ss", { trim: false });
});
Vue.filter("timeFromSecondsToStringFriendly", function(value) {
	if (!value) return "00:00:00";

	var tt = moment.duration(value, "seconds");

	var time = tt.format("H:m:s", { trim: false });
	var timeSplit = time.split(":");

	if (parseInt(timeSplit[0]) > 0) {
		return `${timeSplit[0]}h${timeSplit[1]}'`;
	}

	return `${timeSplit[1]}'${timeSplit[2]}''`;
});
Vue.filter("timeFromSecondsToStringHorM", function(value) {
	if (!value) return "";

	var tt = moment.duration(value, "seconds");

	var time = tt.format("H:m", { trim: false });
	var timeSplit = time.split(":");

	if (parseInt(timeSplit[0]) > 0) {
		return `${timeSplit[0]}h ${timeSplit[1]}m`;
	}

	return `${timeSplit[1]} min`;
});

Vue.filter("stringToDouble", function(value) {
	if (this._.isNil(value) || this._.isNaN(value)) return "";

	return value.toFixed(2).replace(".", ",");
});


kendo.culture("it-IT");
kendo.culture().calendar.firstDay = 1;

kendo.culture().numberFormat.decimals = 2;
kendo.culture().numberFormat[","] = ".";
kendo.culture().numberFormat["."] = ",";

kendo.culture().calendars.standard.months.names = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
kendo.culture().calendars.standard.months.namesAbbr = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

kendo.culture().calendars.standard.days.names = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
kendo.culture().calendars.standard.days.namesAbbr = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
kendo.culture().calendars.standard.days.namesShort = ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"];

export const bus = new Vue();

// const itMessages = {
// 	grid: {
// 		pagerInfo: "{2} elementi",
// 		noRecords: "Nessun dato presente"
// 	}
// };

// loadMessages(itMessages, "it-IT");



window.helpers = require("./shared/fleetbox-helpers");

//Vue.use(router);

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

const itServerMessages = {
	"grid": {
		"pagerInfo": "{0} - {1} di {2} elementi",
		"noRecords": "Nessun dato presente"
	}
};

loadMessages(itServerMessages, "its-ITS");

Vue.use(GlobalComponents);

Vue.use(VueGoogleMaps, {
	installComponents: true
});
Vue.component('GmapCluster', GmapCluster);

const options = {};
Vue.use(VueLodash, options);

/* SECURE ROUTE */
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!FleerunStore.store.getters.isLoggedIn && to.fullPath != "/login") {
			next({
				name: "login",
				params: {
					nextUrl: to.fullPath
				}
			});
		} else if (
			FleerunStore.store.getters.scopes == null ||
			FleerunStore.store.getters.scopes.length == 0 ||
			(to.meta.permission &&
				FleerunStore.store.getters.scopes.some(item => {
					return item == to.meta.permission;
				}) == false)
		) {
			FleerunStore.store.dispatch("logout");
			next({
				name: "login",
				params: {
					nextUrl: to.fullPath
				}
			});
		} else {
			next();
		}
	} else if (!to.name) {
		FleerunStore.store.dispatch("logout");
		next({
			name: "login",
			params: {
				nextUrl: to.fullPath
			}
		});
	} else {
		next();
	}
});

new Vue({
	router,
	store: FleerunStore.store,
	render: h => h(App)
}).$mount("#app");
